"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "follo": {
    "356a75ed": [{
      "hkey": "3847e5db",
      "slug": "follomonte",
      "name": "Follomonte",
      "primary": true,
      "skipSearch": false
    }],
    "follo-alto": [{
      "hkey": "3847e5db",
      "slug": "follomonte",
      "name": "Follomonte",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;